// extracted by mini-css-extract-plugin
export default {"buttons":"login_buttons__FQ5nD","background":"login_background__k4uaX","logo":"login_logo__3gKCZ"};